module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-info"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.currentTabClick
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "公司基础信息",
      "name": "baseInfo"
    }
  }, [_c('company-tab')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "联系人",
      "name": "contact"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("全部联系人")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleContactsDialogOpen()
      }
    }
  }, [_vm._v("新增联系人")])], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入联系人"
    },
    model: {
      value: (_vm.contactSearch.Name),
      callback: function($$v) {
        _vm.contactSearch.Name = $$v
      },
      expression: "contactSearch.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办事处"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "clearable": "",
      "options": _vm.Provinces,
      "props": {
        value: 'Id',
        label: 'Name',
        children: 'children'
      },
      "placeholder": "请选择办事处（省/市/区）"
    },
    on: {
      "active-item-change": _vm.handleItemChange
    },
    model: {
      value: (_vm.contactSearch.Place),
      callback: function($$v) {
        _vm.contactSearch.Place = $$v
      },
      expression: "contactSearch.Place"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "120px",
      "background": "#20a0ff"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.IsLoading
    },
    on: {
      "click": _vm.getCustomers
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    staticClass: "table-shin-expand",
    attrs: {
      "element-loading-text": "加载中",
      "data": _vm.Customers
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "inner-form",
          attrs: {
            "inline": true,
            "label-width": "120px",
            "label-suffix": "："
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "生日",
            "prop": "Birthdate"
          }
        }, [_vm._v(_vm._s(_vm._f("date")(props.row.Birthdate, 'YYYY-MM-DD')))]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "手机号",
            "prop": "Mobile"
          }
        }, [_vm._v(_vm._s(props.row.Mobile))]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "QQ",
            "prop": "QQ"
          }
        }, [_vm._v(_vm._s(props.row.QQ))]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "微信",
            "prop": "Weixin"
          }
        }, [_vm._v(_vm._s(props.row.Weixin))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职位",
      "prop": "JobTitle"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "办事处",
      "width": "300px",
      "prop": "StreetAddress"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handleContactsDialogOpen(props.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (props.row.Accounts.length === 0) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handleCreatePermissionsDialogOpen(props.row)
            }
          }
        }, [_vm._v("分配账户及权限")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticClass: "danger",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handleRemoveContacts(props.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('el-pagination', {
    staticClass: "text-right",
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.contactTotal
    },
    on: {
      "current-change": _vm.getCustomers
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "账户及权限",
      "name": "permissions"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("账户及权限")])])], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请输入联系人"
    },
    model: {
      value: (_vm.permissionSearch.Name),
      callback: function($$v) {
        _vm.permissionSearch.Name = $$v
      },
      expression: "permissionSearch.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分部"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "请选择或输入分部",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.permissionSearch.PartnerRegionId),
      callback: function($$v) {
        _vm.permissionSearch.PartnerRegionId = $$v
      },
      expression: "permissionSearch.PartnerRegionId"
    }
  }, _vm._l((_vm.Regions), function(Region) {
    return _c('el-option', {
      key: Region.Code,
      attrs: {
        "label": Region.Name,
        "value": Region.Code
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "120px",
      "background": "#20a0ff"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.IsLoading
    },
    on: {
      "click": _vm.getPartnerAccounts
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    staticClass: "table-shin-expand",
    attrs: {
      "element-loading-text": "加载中",
      "data": _vm.PartnerAccounts
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "inner-form",
          attrs: {
            "inline": true,
            "label-width": "120px",
            "label-suffix": "："
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "拥有权限"
          }
        }, _vm._l((props.row.Permission), function(item) {
          return _c('span', {
            key: item,
            staticClass: "permission"
          }, [_vm._v(_vm._s(_vm._f("Permissions")(item)))])
        }))], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分部",
      "prop": "RegionName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "账户",
      "prop": "CustomerName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "220px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handlePermissionsDialogOpen(props.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticClass: "danger",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.handleRemovePermissions(props.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('el-pagination', {
    staticClass: "text-right",
    attrs: {
      "layout": "total, prev, pager, next",
      "current-page": _vm.permissionPage,
      "total": _vm.permissionTotal
    },
    on: {
      "current-change": _vm.permissionPageChange,
      "update:currentPage": function($event) {
        _vm.permissionPage = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('contacts-dialog', {
    attrs: {
      "show": _vm.ContactsDialog.show,
      "form": _vm.ContactsDialog.Form,
      "title": _vm.ContactsDialog.Form.Id ? '编辑联系人' : '新增联系人'
    },
    on: {
      "update:show": function($event) {
        _vm.ContactsDialog.show = $event
      },
      "confirm": _vm.handleContactsConfirm
    }
  }), _vm._v(" "), _c('permissions-dialog', {
    attrs: {
      "show": _vm.PermissionsDialog.show,
      "form": _vm.PermissionsDialog.Form,
      "contactName": _vm.ContactName,
      "title": _vm.PermissionMethod === 'update' ? '编辑账号' : '新增账号',
      "callbackMethod": _vm.PermissionMethod
    },
    on: {
      "update:show": function($event) {
        _vm.PermissionsDialog.show = $event
      },
      "create": _vm.handlePermissionsCreate,
      "update": _vm.handlePermissionsUpdate
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46cf963c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ProfilePage/CustomerInfoModule.vue
// module id = 731
// module chunks = 0